import { autoinject, bindable, bindingMode, customElement } from 'aurelia-framework';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { DataService } from 'DataAccessLayer/Services/DataService';


@customElement('operator-card')
@autoinject
export class OperatorCardCustomElement extends BaseCustomElement {
  protected entityName: string = 'Operator';
  @bindable entityId: number = null;
  protected operatorData: any = null;

  protected dataService: DataService = null;
  constructor(dataService: DataService) {
    super();
    this.dataService = dataService;
  }

  async bind() {
    let response: any = await this.dataService.GetById('Operator', this.entityId);
    if (ObjectHelper.ObjectIs(response) && ObjectHelper.ObjectIs(response.data)) {
      this.operatorData = response.data;
    }
  }


}
